import React from 'react'
import StaffCreateForm from '../../forms/StaffCreateForm'

function StaffAdminCreate() {
  return (
    <div>
        <StaffCreateForm />
    </div>
  )
}

export default StaffAdminCreate